<div class="settings">
  <div class="settings__header">
    <button
      tuiIconButton
      class="settings__return-button"
      type="button"
      appearance="icon"
      iconStart="@tui.arrow-left"
      size="s"
      [tuiHint]="'common.buttons.return' | translate"
      [routerLink]="'/chats-inner'"
    ></button>

    <h1 class="settings__title">
      {{ 'components.internalMessenger.labels.settingsTitle' | translate }}
    </h1>
  </div>

  <app-notifications></app-notifications>
</div>
